// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"40":"add","391":"div","435":"sub","971":"mul"}[chunkId] || chunkId) + "." + {"40":"4b1bdfa4","391":"a9350b4c","435":"a9ad35e7","528":"241015c3","971":"6d721040"}[chunkId] + ".css";
};